import { useEffect, useRef, useState } from "react";
import { customersAPI } from "../../api/customerAPI";

export default function CustomerTypeSearch({ setCusCode, setCusName, pCode, setIsAllCustomersChecked }) {
    const [allCustomers, setAllCustomers] = useState([]);

    const isFirstRender = useRef(false);

    const getCustomers = (searchKey = '') => {
        customersAPI.getCustomers(pCode, searchKey).then((data) => {
            setAllCustomers(data);
        })
    }

    const handleRowSelect = (code, name) => {
        setCusCode(code);
        setCusName(name);
        setIsAllCustomersChecked(false);
    }

    useEffect(() => {
        if (!isFirstRender.current) {
            isFirstRender.current = true;
            getCustomers()
        }
    }, []);

    return (
        <div className="modal fade" id="customerTypeSearch" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Customers</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>

                    <div className="modal-body">
                        <input type="text" className="form-control" placeholder="Search by code or name"
                            onChange={(e) => getCustomers(e.target.value)}
                        />
                        <table className="table mt-1">
                            <thead className="thead--color">
                                <tr>
                                    <th scope="col">Code</th>
                                    <th scope="col">Name</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allCustomers && allCustomers.map(data => (
                                    <tr key={data.cusCode}>
                                        <td>{data.cusCode}</td>
                                        <td>{data.cusName}</td>
                                        <td className="text-center"><button type="button" className="btn btn-sm btn-dark"
                                            onClick={() => handleRowSelect(data.cusCode, data.cusName)} data-bs-dismiss="modal">
                                            Select</button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}